import { forwardRef } from "react";
import { PhraseText, SoundVisualizerRef } from "../../types";
import { Center, Text, VStack } from "@chakra-ui/react";
import { BarSoundVisualizerV2 } from "../atoms/BarSoundVisualizerV2";
import { CALIBRATION_MIN_LOG_POWER } from "../../constants";
import { decibelToVolume } from "../../utils/calcVolume";

type PhraseVisualizerProps = {
  currentPhrase: PhraseText;
  showThreshold?: boolean;
  isRecording?: boolean;
};
export const PhraseBarSoundVisualizer = forwardRef<
  SoundVisualizerRef,
  PhraseVisualizerProps
>((props, ref) => {
  const underThreshold = decibelToVolume(CALIBRATION_MIN_LOG_POWER);
  return (
    <VStack width="100%" spacing={5} align="stretch">
      <BarSoundVisualizerV2
        ref={ref}
        upperThreshold={0.81}
        underThreshold={underThreshold}
        maxValue={1}
        height="40px"
        width="100%"
        showThreshold={props.showThreshold}
        isRecording={props.isRecording}
      />

      <Center
        minHeight={{
          base: "200px",
          sm: "350px",
        }}
        fontSize={{
          base: "2xl",
          sm: "4xl",
        }}
        textAlign="center"
        whiteSpace="pre-wrap"
        color="primary.theme_lv1"
        fontWeight={900}
        lineHeight={1.2}
        width="100%"
        borderWidth="2px"
        borderStyle="solid"
        borderColor="primary.theme_lv1"
        bg="common.base"
      >
        {props.currentPhrase.phrase}
      </Center>

      {props.currentPhrase.helperText && (
        <Text
          alignSelf="center"
          textAlign="center"
          whiteSpace="pre-wrap"
          fontSize={{
            base: "xl",
            sm: "3xl",
          }}
        >
          {props.currentPhrase.helperText}
        </Text>
      )}
    </VStack>
  );
});
PhraseBarSoundVisualizer.displayName = "PhraseVisualizer";
